const sections = [
  {
    title: "1. Agreement to these Terms",
    body: [
      "These Terms of Service govern your access to and use of iBox, including the iBox website, desktop application, downloadable software, local browser-source output, documentation, and related services we provide. By downloading, installing, accessing, or using iBox, you agree to these Terms.",
      "If you do not agree to these Terms, do not use iBox.",
    ],
  },
  {
    title: "2. What iBox provides",
    body: [
      "iBox is a broadcast app toolkit for streamers, broadcasters, league producers, and content creators. iBox allows users to configure broadcast graphics, widgets, overlays, browser-source outputs, and related streaming tools for use with compatible streaming software.",
      "iBox includes free and paid features. Available features, supported platforms, integrations, pricing, and app capabilities may change over time.",
    ],
  },
  {
    title: "3. Eligibility",
    body: [
      "You must be at least 18 years old, or the age of legal majority where you live, to use iBox.",
      "By using iBox on behalf of a team, league, company, or other organization, you represent that you have authority to accept these Terms on that organization's behalf.",
    ],
  },
  {
    title: "4. Accounts and security",
    body: [
      "iBox features require an account. You agree to provide accurate information, keep your login credentials secure, and notify us if you believe your account has been accessed without permission.",
      "You are responsible for activity that occurs through your account or through your local installation of iBox.",
    ],
  },
  {
    title: "5. Payments and subscriptions",
    body: [
      "Some iBox features require a paid subscription. Prices, billing intervals, available plans, and included features will be shown before purchase.",
      "Payments are processed by our payment provider. We do not store full payment card details. By purchasing a paid plan, you authorize the applicable recurring charges.",
      "Unless otherwise stated at checkout, subscription fees are billed in advance and are non-refundable except where required by law. You may cancel a subscription according to the cancellation process made available in iBox or through our billing provider.",
    ],
  },
  {
    title: "6. Local data, assets, and user content",
    body: [
      "iBox allows you to add, create, import, upload, configure, or display content such as text, images, logos, graphics, brand assets, textures, social handles, RSS feeds, and other materials. You retain ownership of content you provide.",
      "You grant iBox the limited permission necessary to process, display, transform, resize, crop, recolor, normalize, and otherwise use your content so iBox can provide the features you choose to use.",
      "You are responsible for ensuring that you have the rights, licenses, and permissions needed for any logos, trademarks, images, fonts, media, RSS feeds, names, handles, or other content you use with iBox.",
    ],
  },
  {
    title: "7. Third-party services and content",
    body: [
      "iBox may integrate with or display information from third-party platforms, websites, APIs, feeds, or services. Third-party services are not controlled by iBox and may change, stop working, restrict access, or provide inaccurate or delayed data.",
      "Your use of third-party services may be subject to separate terms, policies, account requirements, rate limits, and permissions from those third parties.",
    ],
  },
  {
    title: "8. Acceptable use",
    body: [
      "You agree not to misuse iBox. You may not use iBox to violate laws, infringe intellectual property rights, harass others, distribute malware, scrape or overload systems without permission, bypass security controls, interfere with iBox operations, or misrepresent your relationship with any person, brand, league, platform, or organization.",
      "You may not reverse engineer, decompile, resell, sublicense, rent, lease, or redistribute iBox except as allowed by applicable law or with our written permission.",
    ],
  },
  {
    title: "9. Software updates and availability",
    body: [
      "iBox may provide updates, bug fixes, new features, modified features, or discontinued features. Some updates may be required for continued compatibility, security, or access to certain functionality.",
      "We work to keep iBox useful and reliable, but we do not guarantee that iBox will be uninterrupted, error-free, compatible with every system, compatible with every streaming setup, or available at all times.",
    ],
  },
  {
    title: "10. Intellectual property",
    body: [
      "iBox, the iBox name, logos, branding, software, interface designs, documentation, visual systems, and related materials are owned by iBox or its licensors and are protected by intellectual property laws.",
      "These Terms do not transfer ownership of iBox intellectual property to you. You receive only the limited right to use iBox as described in these Terms.",
    ],
  },
  {
    title: "11. Feedback",
    body: [
      "If you send us ideas, suggestions, designs, bug reports, feature requests, or other feedback, you allow us to use that feedback without restriction or compensation to you. You are not required to provide feedback.",
    ],
  },
  {
    title: "12. Disclaimers",
    body: [
      "iBox is provided on an \"as is\" and \"as available\" basis. To the fullest extent allowed by law, we disclaim all warranties, express or implied, including warranties of merchantability, fitness for a particular purpose, non-infringement, availability, accuracy, and reliability.",
      "iBox is a broadcast and configuration tool. You are responsible for testing your setup before live use, maintaining backups of important configurations and assets, and confirming that your overlays, sources, graphics, and streams work as intended.",
    ],
  },
  {
    title: "13. Limitation of liability",
    body: [
      "To the fullest extent allowed by law, iBox and its owners, operators, contributors, and affiliates will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages, including lost profits, lost revenue, lost data, stream interruption, lost sponsorship value, lost goodwill, or business interruption.",
      "To the fullest extent allowed by law, our total liability for any claim related to iBox will not exceed the amount you paid to iBox for the service or software giving rise to the claim during the three months before the claim arose, or one hundred U.S. dollars if you paid nothing.",
    ],
  },
  {
    title: "14. Indemnification",
    body: [
      "You agree to defend, indemnify, and hold harmless iBox and its owners, operators, contributors, and affiliates from claims, damages, losses, liabilities, costs, and expenses arising from your use of iBox, your content, your violation of these Terms, or your violation of another person's rights.",
    ],
  },
  {
    title: "15. Suspension or termination",
    body: [
      "We may suspend or terminate access to iBox if we believe you have violated these Terms, created risk for iBox or other users, failed to pay applicable fees, or used iBox in a way that may cause legal, technical, security, or reputational harm.",
      "You may stop using iBox at any time. Sections that by their nature should survive termination will continue to apply, including intellectual property, disclaimers, limitation of liability, indemnification, and dispute provisions.",
    ],
  },
  {
    title: "16. Changes to these Terms",
    body: [
      "We may update these Terms from time to time. When we do, we will update the \"Last updated\" date. Continued use of iBox after updated Terms become effective means you accept the updated Terms.",
    ],
  },
  {
    title: "17. Governing law",
    body: [
      "These Terms are governed by the laws of the State of California, without regard to its conflict of law principles, except where applicable law requires otherwise.",
    ],
  },
  {
    title: "18. Contact",
    body: [
      "Questions about these Terms can be sent through the contact page on the iBox website.",
    ],
  },
];

export function TermsPage() {
  return (
    <main className="relative min-h-screen overflow-hidden pt-16">
      <div className="download-bg absolute inset-0 z-0 bg-bg">
        <div className="absolute inset-0 bg-gt-grid opacity-35" />
        <div className="absolute inset-0 bg-bg/40" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-gradient-to-b from-transparent to-bg" />
      </div>

      <section className="relative z-10 mx-auto max-w-4xl px-6 py-24">
        <div className="mb-12">
          <div className="mb-6 flex items-center gap-3">
            <div className="h-px w-10 bg-primary" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-primary">Legal</span>
          </div>
          <h1 className="font-display text-6xl font-bold uppercase leading-[0.9] text-text md:text-8xl">Terms of Service</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted md:text-lg">
            Last updated: May 26, 2026
          </p>
        </div>

        <div className="rounded-xl border border-border bg-surface/92 shadow-2xl shadow-black/20">
          <div className="border-b border-border p-6 md:p-8">
            <p className="text-base leading-relaxed text-muted">
              Please read these Terms carefully. They explain the rules that apply when you use iBox.
            </p>
          </div>
          <div className="divide-y divide-border">
            {sections.map((section) => (
              <section key={section.title} className="p-6 md:p-8">
                <h2 className="font-display text-2xl font-bold uppercase leading-none text-text md:text-3xl">{section.title}</h2>
                <div className="mt-4 space-y-4">
                  {section.body.map((paragraph) => (
                    <p key={paragraph} className="text-sm leading-7 text-muted md:text-base">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
